import React, { useEffect, useState } from 'react';

import useApi from '@/hooks/useApi';

import { TTemplateTypes } from '@/components/Template/types';
import { SkeletonTemplate2 } from '@/components/Template/Template2/Skeleton';
import { SkeletonTemplate1 } from '@/components/Template/Template1/Skeleton';
import { SkeletonTemplate7 } from '@/components/Template/Template7/Skeleton';

import { getRecommendationData } from '@/services/requests/Recommendation';
import { TRecommendation as TRecommendation1 } from '@/services/requests/Recommendation/types/template1';
import { TRecommendation as TRecommendation2 } from '@/services/requests/Recommendation/types/template2';
import { TRecommendation as TRecommendation3 } from '@/services/requests/Recommendation/types/template3';
import { TRecommendation as TRecommendation4 } from '@/services/requests/Recommendation/types/template4';
import { TRecommendation as TRecommendation5 } from '@/services/requests/Recommendation/types/template5';
import { TRecommendation as TRecommendation6 } from '@/services/requests/Recommendation/types/template6';
import { TRecommendation as TRecommendation7 } from '@/services/requests/Recommendation/types/template7';
import { TRecommendation as TRecommendation8 } from '@/services/requests/Recommendation/types/template8';

import TemplateVitrine1 from '../TemplateVitrine1';
import TemplateVitrine2 from '../TemplateVitrine2';
import TemplateVitrine3 from '../TemplateVitrine3';
import { TemplateVitrine4 } from '../TemplateVitrine4';
import TemplateVitrine5 from '../TemplateVitrine5';
import TemplateVitrine6 from '../TemplateVitrine6';
import TemplateVitrine7 from '../TemplateVitrine7';
import TemplateVitrine8 from '../TemplateVitrine8';

type TRecommendationFetch = {
  id: string;
  place: string;
  channel: string;
  template: string;
  layout: string;
  type: string;
  supportGeolocation?: boolean;
};

export function RecommendationFetch({
  id,
  place,
  channel,
  template,
  type,
  layout,
  supportGeolocation,
}: TRecommendationFetch) {
  const { Api } = useApi();

  const [data, setData] = useState<
    | TRecommendation1[]
    | TRecommendation2[]
    | TRecommendation3[]
    | TRecommendation4[]
    | TRecommendation5[]
    | TRecommendation6[]
    | TRecommendation7[]
    | TRecommendation8[]
  >([]);

  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  async function fetchData() {
    try {
      const result = await getRecommendationData(
        Api,
        id,
        type,
        place,
        channel,
        supportGeolocation,
      );
      setData(result);
      setError(false);
    } catch (err) {
      console.warn(`getRecommendationData: `, err);
      setError(true);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderTemplate1 = () => {
    if (isLoading) {
      return <SkeletonTemplate1 layout={layout} />;
    }

    return <TemplateVitrine1 data={data as TRecommendation1[]} />;
  };

  const renderTemplate2 = () => {
    if (isLoading) {
      return <SkeletonTemplate2 layout={layout} />;
    }

    return <TemplateVitrine2 data={data as TRecommendation2[]} />;
  };

  const renderTemplate3 = () => {
    if (isLoading) {
      return <SkeletonTemplate1 layout={layout} />;
    }

    return <TemplateVitrine3 data={data as TRecommendation3[]} />;
  };

  const renderTemplate4 = () => {
    if (isLoading) {
      return <SkeletonTemplate1 layout={layout} />;
    }

    return <TemplateVitrine4 data={data as TRecommendation4[]} />;
  };

  const renderTemplate5 = () => {
    if (isLoading) {
      return <SkeletonTemplate1 layout={layout} />;
    }

    return <TemplateVitrine5 data={data as TRecommendation5[]} />;
  };

  const renderTemplate6 = () => {
    if (isLoading) {
      return <SkeletonTemplate1 layout={layout} />;
    }

    return <TemplateVitrine6 data={data as TRecommendation6[]} />;
  };

  const renderTemplate7 = () => {
    if (isLoading) {
      return <SkeletonTemplate7 />;
    }

    return <TemplateVitrine7 data={data as TRecommendation7[]} />;
  };

  const renderTemplate8 = () => {
    if (isLoading) {
      return <SkeletonTemplate1 layout={layout} />;
    }

    return <TemplateVitrine8 data={data as TRecommendation8[]} />;
  };

  const render = (key: TTemplateTypes) => {
    console.log('key', key);
    const renderFunctions = {
      '1': () => renderTemplate1(),
      '2': () => renderTemplate2(),
      '3': () => renderTemplate3(),
      '4': () => renderTemplate4(),
      '5': () => renderTemplate5(),
      '6': () => renderTemplate6(),
      '7': () => renderTemplate7(),
      '8': () => renderTemplate8(),
    };
    return renderFunctions[key]();
  };

  if (error) return null;

  return render(template as TTemplateTypes);
}
